module.exports = __webpack_public_path__ + "static/media/news-newborn-pack.8e0b25fc.png";